import React, { Component } from 'react';
import PropTypes from 'prop-types';
import syncPushState from '../../lib/syncPushState';
import Filter from './Filter';
import Checkbox from '../Checkbox';

export default class CheckboxFilter extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.array,
    selected: PropTypes.array,
    defaultValue: PropTypes.array,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    options: [],
    selected: [],
    defaultValue: [],
    onChange() {},
  }

  constructor(props) {
    super(props);
    const selected = this.props.selected.filter((s) => this.props.options.map((o) => o.id).includes(s));
    this.state = {
      selected: this.props.selected.length === 0 ? [].concat(this.props.defaultValue) : selected,
    };
  }

  handleChange = (e) => {
    const checkbox = e.target;
    const { selected } = this.state;
    if (checkbox.checked) {
      selected.push(checkbox.id);
    } else {
      selected.splice(selected.indexOf(checkbox.id), 1);
    }
    this.setState({ selected }, () => {
      syncPushState(this.props.id, selected);
    });

    this.props.onChange('selected', { id: this.props.id, selected });
  }

  handleLocalResetClick = () => {
    const selected = [].concat(this.props.defaultValue);
    this.setState({ selected }, () => {
      syncPushState(this.props.id, []);
    });

    this.props.onChange('selected', { id: this.props.id, selected });
  }

  handleGlobalResetClick = () => {
    const selected = [].concat(this.props.defaultValue);
    this.setState({ selected });

    this.props.onChange('selected', { id: this.props.id, selected });
  }

  render() {
    const {
      id, title, expanded, onChange,
    } = this.props;

    const hasSelectedValues = !this.state.selected.reduce((acc, item) => {
      return acc && (this.state.selected.length === this.props.defaultValue.length) && this.props.defaultValue.includes(item);
    }, true);

    return (
      <Filter
        id={id}
        title={title}
        expanded={expanded}
        hasSelected={hasSelectedValues}
        onChange={onChange}
        onLocalReset={this.handleLocalResetClick}
        onGlobalReset={this.handleGlobalResetClick}
      >
        <div className="Form u-px-4 u-pb-2">
          {this.props.options.map((option) => {
            const checked = this.state.selected.indexOf(option.id) !== -1;
            return (
              <Checkbox
                key={option.id}
                id={option.id}
                className={`u-m-0 ${option.class_name}`}
                wrapperClassName="checkbox--outline"
                checked={checked}
                onChange={this.handleChange}
              >
                {option.name}
              </Checkbox>
            );
          })}
        </div>
      </Filter>
    );
  }
}
